/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 機器情報
 */
export interface Szma301aResDeviceInfoDto {
    /**
     * 高効率給湯器
     */
    highefficiencyWaterheater?: string;
    /**
     * 高効率給湯器有無名称
     */
    highefficiencywaterheaterUmuAname?: string;
    /**
     * その他給湯器
     */
    etcWaterheater?: string;
    /**
     * その他給湯器有無名称
     */
    etcwaterheaterUmuAname?: string;
    /**
     * 厨房機器
     */
    kitchenequipment?: string;
    /**
     * 厨房機器有無名称
     */
    kitchenequipmentUmuAname?: string;
    /**
     * 床暖房
     */
    yukadanbo?: string;
    /**
     * 床暖房有無名称
     */
    yukadanboUmuAname?: string;
    /**
     * 浴室暖房乾燥機
     */
    bathroomheatingDryer?: string;
    /**
     * 浴室暖房乾燥機有無名称
     */
    bathroomheatingdryerUmuAname?: string;
    /**
     * その他暖房機
     */
    etcHeatmachine?: string;
    /**
     * その他暖房機有無名称
     */
    etcheatmachineUmuAname?: string;
    /**
     * 空調機器
     */
    airconditioning?: string;
    /**
     * 空調機器有無名称
     */
    airconditioningUmuAname?: string;
    /**
     * コージェネ機器
     */
    cogenerationDevice?: string;
    /**
     * コージェネ機器有無名称
     */
    cogenerationdeviceUmuAname?: string;
    /**
     * 第一群
     */
    group1?: string;
    /**
     * 第一群有無名称
     */
    group1UmuAname?: string;
    /**
     * 第二群
     */
    group2?: string;
    /**
     * 第二群有無名称
     */
    group2UmuAname?: string;
    /**
     * 第三群
     */
    group3?: string;
    /**
     * 第三群有無名称
     */
    group3UmuAname?: string;
    /**
     * 第四群
     */
    group4?: string;
    /**
     * 第四群有無名称
     */
    group4UmuAname?: string;
}

